import React, { useEffect, useState, useCallback } from "react";
import { Column } from "@ant-design/plots";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { Spin } from "antd";
import { concat, includes, isNaN, map, max, size } from "lodash";
import { useTranslation } from "react-i18next";

const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  color: #141414;
  margin-bottom: 10px;
`;

const StyledChartContainer = styled.div`
  border: solid 1px #9b9b9b;
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 25px;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
  }
`;

function DemographicsGenderDiversity({ report }) {
  const { t } = useTranslation();

  const memoizedFormatter = useCallback((value) => {
    return value ? value.slice(0, 3) : value;
  }, []);

  const config = {
    data: report,
    isStack: true,
    height: 300,
    xField: "departmentName",
    yField: "count",
    seriesField: "sex",
    label: {
      position: "middle",
      content: "",
    },
    columnStyle: {
      cursor: "pointer",
    },
    legend: {
      layout: "horizontal",
      position: "top",
    },
    yAxis: {
      // max: isNaN(max(map(reportData, 'count'))) ? 100 : max(map(reportData, 'count')) + 25,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
    xAxis: {
      label: {
        formatter: memoizedFormatter,
        offset: 10,
        autoHide: false,
        autoRotate: true,
      },
    },
    // theme: {
    //   colors10: [
    //     // '#0F1C73',
    //     // '#1A449F',
    //     '#2B67BA',
    //     '#3C88C0',
    //     '#4BA7B3',
    //     '#5AC39B',
    //     '#6ADD7F',
    //     '#A8DD6A',
    //     '#DDDD6A',
    //   ],
    // },
  };

  return (
    <>
      <StyledTitle>{t("Gender Diversity")}</StyledTitle>
      <StyledChartContainer>
        <Column {...config} />
      </StyledChartContainer>
    </>
  );
}

export default DemographicsGenderDiversity;
